import { z } from 'zod';
import { toIso } from './util';

export const CUSTOMER_TYPES = ['client', 'vendor', 'both'] as const;
export const CUSTOMER_STATUSES = ['active', 'prospect', 'inactive'] as const;

export const AddressSchema = z
  .object({
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    postal: z.string().optional(),
    country: z.string().optional(),
  })
  .partial();
export type Address = z.infer<typeof AddressSchema>;

export const CustomerSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    type: z.enum(CUSTOMER_TYPES),
    status: z.enum(CUSTOMER_STATUSES),
    industry: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().optional(),
    contactName: z.string().optional(),
    billing: AddressSchema.optional(),
    shipping: AddressSchema.optional(),
    tags: z.array(z.string()).optional(),
    notes: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
  })
  .passthrough();

export type Customer = z.infer<typeof CustomerSchema>;

export interface NewCustomerOptions {
  id: string;
  name: string;
  type?: Customer['type'];
  status?: Customer['status'];
  now?: Date | string;
}

/** Build a fresh customer record with sane defaults (client / prospect). */
export function newCustomer(opts: NewCustomerOptions): Customer {
  const ts = toIso(opts.now);
  return {
    id: opts.id,
    name: opts.name,
    type: opts.type ?? 'client',
    status: opts.status ?? 'prospect',
    createdAt: ts,
    updatedAt: ts,
  };
}
